/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicostsmonthlabel3Inputs */

const en_aicostsmonthlabel3 = /** @type {(inputs: Aicostsmonthlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Month`)
};

const de_aicostsmonthlabel3 = /** @type {(inputs: Aicostsmonthlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monat`)
};

/**
* | output |
* | --- |
* | "Month" |
*
* @param {Aicostsmonthlabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostsmonthlabel3 = /** @type {((inputs?: Aicostsmonthlabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostsmonthlabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostsmonthlabel3(inputs)
	return de_aicostsmonthlabel3(inputs)
});
export { aicostsmonthlabel3 as "aiCostsMonthLabel" }